import styled from "styled-components";
import pokemons from "../../../assets/pokemons.jpg";
import PokemonsTechIcons from "../pokemonsProject/PokemonsTechIcons";
import PokemonsDescription from "./PokemonsDescription";
import ProjectBtns from "../ProjectBtns";

export default function Twitter() {
  return (
    <ProjectContainer>
      <ProjectDesc>
        <h2>Pokemons App</h2>
        <p>
          In this React app, I've worked with fetched data, managed state, React
          routes, and more.
        </p>
        <div>
          <Features>Used technologies:</Features>
          <PokemonsTechIcons />
        </div>
        <div>
          <Features>Features/Description:</Features>
          <PokemonsDescription />
        </div>
      </ProjectDesc>
      <ProjectBtns>
        <button>
          <a
            href="https://kamilpokemonapp.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Try it live
          </a>
        </button>
        <button>
          <a
            href="https://github.com/Kamildeeal/Pokemons_APP_React_TS"
            target="_blank"
            rel="noopener noreferrer"
          >
            View source
          </a>
        </button>
      </ProjectBtns>
      <Overview>
        <h2>Hover to see overview</h2>
        <div>
          <ProjectImageWrapper>
            <ProjectImage src={pokemons} alt="pokemons_teaser" />
          </ProjectImageWrapper>
        </div>
      </Overview>
    </ProjectContainer>
  );
}

const ProjectDesc = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  & > p {
    margin-bottom: 20px;
  }

  & > h2 {
    color: rgba(246, 135, 38, 0.8);
  }

  & > h2,
  div {
    margin-bottom: 20px;
    @media (max-width: 460px) {
      margin-bottom: 10px;
    }
  }
`;

const ProjectContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  margin-top: 30px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  overflow: hidden;
  color: white;
  padding: 10px 20px;
  margin-bottom: 80px;
  transition: all 0.1s ease;

  &:hover {
    background: rgba(36, 36, 41, 0.87);
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
  @media (max-width: 460px) {
    margin-bottom: 16px;
  }
`;

const ProjectImageWrapper = styled.div`
  position: relative;
  width: 500px;
  height: 400px;
  overflow: hidden;
  border-radius: 8px;
  border: 2px solid black;

  &:hover img {
    transform: translateY(-23%);
  }
`;

const Overview = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;

  > h2 {
    margin-bottom: 10px;
  }

  @media (max-width: 1024px) {
    align-items: center;
    justify-content: center;
    r > h2 {
      justify-content: center;
    }
  }
  @media (max-width: 670px) {
    display: none;
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 2s ease-in-out;
`;

const Features = styled.div`
  color: rgba(246, 135, 38, 0.8);
  font-weight: bold;
  margin-bottom: 0 !important;
`;
